let CookieCategories = /*#__PURE__*/function (CookieCategories) {
  CookieCategories["NECESSARY"] = "9";
  CookieCategories["PERFORMANCE"] = "1";
  CookieCategories["PERSONALIZATION"] = "6";
  return CookieCategories;
}({});
const COOKIE_CATEGORIES = Object.values(CookieCategories);

const initSelection = {
  [CookieCategories.NECESSARY]: true,
  [CookieCategories.PERSONALIZATION]: false,
  [CookieCategories.PERFORMANCE]: false
};
const fullSelection = {
  ...initSelection,
  [CookieCategories.PERSONALIZATION]: true,
  [CookieCategories.PERFORMANCE]: true
};
const CONSENT_MANAGER_INITIAL_SLICE_STATE = {
  modalOpen: true,
  consent: false,
  hidden: false,
  selection: initSelection,
  initiator: undefined
};

/**
 * Parse the cookie value object from tealium.
 */
const parseCookieValues = values => {
  const selection = [CookieCategories.PERFORMANCE, CookieCategories.NECESSARY, CookieCategories.PERSONALIZATION].reduce((prev, category) => ({
    ...prev,
    [category]: Boolean(Number(values?.[`c${category}`]))
  }), {});
  return {
    consent: values?.consent === 'true',
    selection
  };
};

export { CookieCategories as C, CONSENT_MANAGER_INITIAL_SLICE_STATE as a, COOKIE_CATEGORIES as b, fullSelection as f, initSelection as i, parseCookieValues as p };
//# sourceMappingURL=parseCookieValues-9a061b22.js.map
